export default "__VITE_ASSET__DWMhlsXH__"